{
  "marks": [
    {
      "emoji": "🥤",
      "icon": "protein-drink",
      "words": {
        "en": ["protein drink", "protein milk", "protein milkshake"],
        "he": ["משקה חלבון", "מילקשייק חלבון", "חלב חלבון"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "protein-powder",
      "words": {
        "en": ["protein powder", "whey", "casein", "isolate", "mass gainer", "gainer"],
        "he": ["אבקת חלבון", "חלבון מי גבינה"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "creatine",
      "words": {
        "en": ["creatine", "collagen", "bcaa", "preworkout", "pre workout", "glutamine", "eaa$"],
        "he": ["קריאטין", "קולגן", "בי סי איי איי"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "protein-bar",
      "words": {
        "en": ["protein bar"],
        "he": ["חטיף חלבון"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "energy-balls",
      "words": {
        "en": ["energy ball", "energy bite", "protein ball", "bliss ball", "date ball"],
        "he": ["כדורי אנרגיה", "כדורי תמרים"]
      }
    },
    {
      "emoji": "🥚",
      "icon": "egg-whites",
      "words": {
        "en": ["egg white", "liquid egg"],
        "he": ["חלבון ביצה", "חלבוני ביצה", "חלבונים"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "french-toast",
      "words": {
        "en": ["french toast", "eggy bread", "pain perdu"],
        "he": ["פרנץ' טוסט", "פרנץ טוסט"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "mac-and-cheese",
      "words": {
        "en": [
          "mac and cheese",
          "mac n cheese",
          "mac & cheese",
          "mac'n'cheese",
          "macaroni and cheese",
          "macaroni cheese"
        ],
        "he": ["מקרוני וגבינה", "מקרוני גבינה"]
      }
    },
    {
      "emoji": "🍰",
      "icon": "cheesecake",
      "words": {
        "en": ["cheesecake", "cheese cake"],
        "he": ["עוגת גבינה"]
      }
    },
    {
      "emoji": "☕",
      "icon": "hot-chocolate",
      "words": {
        "en": ["hot chocolate", "hot cocoa", "drinking chocolate"],
        "he": ["שוקו חם", "שוקולד חם", "קקאו חם"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "chocolate-milk",
      "words": {
        "en": ["chocolate milk", "chocolate drink", "choco milk"],
        "he": ["חלב שוקו", "משקה שוקו", "חלב שוקולד"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "chocolate-spread",
      "words": {
        "en": [
          "chocolate spread",
          "nutella",
          "hazelnut spread",
          "chocolate hazelnut",
          "cocoa spread"
        ],
        "he": ["ממרח שוקולד", "נוטלה", "ממרח לוז"]
      }
    },
    {
      "emoji": "🍪",
      "icon": "cookie-spread",
      "words": {
        "en": ["biscoff", "lotus spread", "cookie butter", "cookie spread", "speculoos"],
        "he": ["ממרח לוטוס", "לוטוס", "ממרח עוגיות"]
      }
    },
    {
      "emoji": "🧋",
      "icon": "iced-tea",
      "words": {
        "en": ["iced tea", "ice tea", "nestea"],
        "he": ["תה קר", "אייס טי"]
      }
    },
    {
      "emoji": "☕",
      "icon": "iced-coffee",
      "words": {
        "en": ["iced coffee", "ice coffee", "iced latte", "cold brew", "frappe", "frappuccino"],
        "he": ["אייס קפה", "קפה קר", "אייס לאטה", "נמס אייס", "נמס קר", "ברד קפה", "אייס$"]
      }
    },
    {
      "emoji": "🍋",
      "icon": "lemonade",
      "words": {
        "en": ["lemonade", "limonana"],
        "he": ["לימונדה", "לימונענע"]
      }
    },
    {
      "emoji": "☕",
      "icon": "cappuccino",
      "words": {
        "en": [
          "cappuccino",
          "latte",
          "flat white",
          "macchiato",
          "cortado",
          "cafe au lait",
          "café au lait"
        ],
        "he": ["קפוצ'ינו", "קפוצינו", "קפה הפוך", "הפוך", "לאטה", "קפה חלב"]
      }
    },
    {
      "emoji": "🍅",
      "icon": "pasta-sauce",
      "words": {
        "en": [
          "pasta sauce",
          "tomato sauce",
          "marinara",
          "passata",
          "pizza sauce",
          "arrabbiata",
          "tomato paste",
          "tomato puree",
          "pomodoro"
        ],
        "he": ["רוטב עגבניות", "רסק עגבניות", "רוטב פסטה", "רוטב פיצה", "פסאטה", "עגבניות מרוסקות"]
      }
    },
    {
      "emoji": "🍆",
      "icon": "baba-ghanoush",
      "words": {
        "en": [
          "baba ghanoush",
          "baba ganoush",
          "baba ghanouj",
          "eggplant dip",
          "aubergine dip",
          "mutabal",
          "moutabal",
          "roasted eggplant",
          "burnt eggplant"
        ],
        "he": [
          "באבא גנוש",
          "בבא גנוש",
          "חציל על האש",
          "חציל שרוף",
          "חציל בטחינה",
          "סלט חצילים",
          "מוטבל"
        ]
      }
    },
    {
      "emoji": "🍆",
      "words": {
        "en": ["aubergine", "eggplant"],
        "he": ["חציל"]
      }
    },
    {
      "emoji": "🥙",
      "icon": "sabich",
      "words": {
        "en": ["sabich", "sabih"],
        "he": ["סביח"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "burger-bun",
      "words": {
        "en": [
          "burger bun",
          "hamburger bun",
          "hot dog bun",
          "brioche bun",
          "bread roll",
          "dinner roll",
          "buns"
        ],
        "he": ["לחמניית המבורגר", "לחמני"]
      }
    },
    {
      "emoji": "🥩",
      "icon": "burger-patty",
      "words": {
        "en": ["patty", "patties"],
        "he": ["קציצת המבורגר"]
      }
    },
    {
      "emoji": "🍔",
      "words": {
        "en": ["hamburger", "cheeseburger"],
        "he": ["המבורגר"]
      }
    },
    {
      "emoji": "🍥",
      "icon": "cinnamon-roll",
      "words": {
        "en": ["cinnamon roll", "cinnamon bun", "cinnabon"],
        "he": ["שבלול", "סינבון", "גלגלת קינמון"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "babka",
      "words": {
        "en": ["babka", "krantz"],
        "he": ["בבקה", "עוגת קראנץ", "עוגת שמרים"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "gummies",
      "words": {
        "en": ["gummy", "gummies", "gummi", "jelly bean", "haribo", "wine gum"],
        "he": ["סוכריות גומי", "דובוני", "גומי"]
      }
    },
    {
      "emoji": "🥪",
      "words": {
        "he": ["סנדביץ", "סנדוויץ"]
      }
    },
    {
      "emoji": "🍝",
      "icon": "penne",
      "words": {
        "he": ["טליאטלה"]
      }
    },
    {
      "emoji": "🍨",
      "words": {
        "en": [
          "gelato",
          "sorbet",
          "frozen yogurt",
          "frozen yoghurt",
          "froyo",
          "sundae",
          "soft serve"
        ],
        "he": ["יוגורט קפוא", "סורבה", "ג'לטו"]
      }
    },
    {
      "emoji": "🍦",
      "words": {
        "en": ["ice cream", "ice cream sandwich", "icecream"],
        "he": ["גליד"]
      }
    },
    {
      "emoji": "🍫",
      "words": {
        "en": ["milk chocolate", "white chocolate", "dark chocolate", "chocolate bar"],
        "he": ["שוקולד חלב", "שוקולד לבן", "שוקולד מריר"]
      }
    },
    {
      "emoji": "🧋",
      "words": {
        "en": ["bubble tea", "boba", "milk tea"],
        "he": ["באבל טי"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "acai-bowl",
      "words": {
        "en": ["smoothie bowl"],
        "he": ["סמוזי בול"]
      }
    },
    {
      "emoji": "🥐",
      "icon": "bourekas",
      "words": {
        "en": ["bourekas", "burekas", "boreka", "borek", "burek"],
        "he": ["בורקס", "בורקאס", "בורקסים"]
      }
    },
    {
      "emoji": "🍱",
      "icon": "meal-prep",
      "words": {
        "en": ["meal prep", "mealprep", "meal box", "lunch box", "lunchbox", "bento"],
        "he": ["מנת צהריים", "קופסת אוכל", "בנטו"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "protein-shake",
      "words": {
        "en": ["protein shake", "shaker"],
        "he": ["שייק חלבון", "חלבון"]
      }
    },
    {
      "emoji": "🧃",
      "icon": "orange-juice",
      "words": {
        "en": ["orange juice"],
        "he": ["מיץ תפוזים", "מיץ תפוז", "תפוזים סחוט"]
      }
    },
    {
      "emoji": "🍘",
      "icon": "rice-cakes",
      "words": {
        "en": ["rice cake", "rice cracker", "corn cake", "rice thin"],
        "he": ["פריכי"]
      }
    },
    {
      "emoji": "🍪",
      "icon": "sandwich-cookies",
      "words": {
        "en": ["oreo", "sandwich cookie", "sandwich biscuit", "bourbon biscuit"],
        "he": ["אוראו"]
      }
    },
    {
      "emoji": "🍪",
      "icon": "biscotti",
      "words": {
        "en": ["biscotti", "cantucci", "mandelbrot"],
        "he": ["ביסקוטי", "מנדלברוט"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "fried-rice",
      "words": {
        "en": ["fried rice", "nasi goreng"],
        "he": ["אורז מטוגן", "אורז מוקפץ", "אורז הפתעות"]
      }
    },
    {
      "emoji": "🍕",
      "words": {
        "en": ["pizza"],
        "he": ["פיצה"]
      }
    },
    {
      "emoji": "🍔",
      "words": {
        "en": ["burger"],
        "he": ["בורגר"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "toast",
      "words": {
        "en": ["toast$", "toasts$", "toastie", "toasted bread", "toasted sandwich"],
        "he": ["טוסט"]
      }
    },
    {
      "emoji": "🥪",
      "words": {
        "en": ["sandwich"],
        "he": ["כריך"]
      }
    },
    {
      "emoji": "🍲",
      "icon": "poke-bowl",
      "words": {
        "en": ["poke", "buddha bowl", "grain bowl", "power bowl", "burrito bowl", "bibimbap"],
        "he": ["פוקי", "באדה בול"]
      }
    },
    {
      "emoji": "🌯",
      "words": {
        "en": ["wrap", "burrito"],
        "he": ["בוריטו"]
      }
    },
    {
      "emoji": "🌮",
      "icon": "quesadilla",
      "words": {
        "en": ["quesadilla"],
        "he": ["קסדיה"]
      }
    },
    {
      "emoji": "🌮",
      "words": {
        "en": ["taco", "enchilada", "fajita", "nacho$"],
        "he": ["טאקו", "פחיטס", "פאחיטס", "אנצ'ילדה"]
      }
    },
    {
      "emoji": "🧆",
      "words": {
        "en": ["falafel", "kubbeh", "kibbeh", "kubba", "arancini"],
        "he": ["פלאפל", "קובה", "קובות", "ארנצ'יני"]
      }
    },
    {
      "emoji": "🥙",
      "words": {
        "en": ["shawarma", "gyro", "doner", "döner"],
        "he": ["שווארמה", "שוורמה", "דונר", "גירוס", "גיירוס"]
      }
    },
    {
      "emoji": "🥘",
      "words": {
        "en": ["paella", "jambalaya", "biryani"],
        "he": ["פאייה", "ביריאני", "מקלובה"]
      }
    },
    {
      "emoji": "🥘",
      "icon": "stir-fry",
      "words": {
        "en": ["stir fry", "stirfry", "wok"],
        "he": ["מוקפץ", "ווק"]
      }
    },
    {
      "emoji": "🥧",
      "icon": "quiche",
      "words": {
        "en": ["quiche", "frittata", "kugel", "kigel"],
        "he": ["קיש$", "פשטיד", "פריטטה", "קוגל", "קיגל", "קישים$"]
      }
    },
    {
      "emoji": "🍳",
      "icon": "omelette",
      "words": {
        "en": ["omelet", "omelette"],
        "he": ["חביתה", "חביתת"]
      }
    },
    {
      "emoji": "🍳",
      "icon": "shakshuka",
      "words": {
        "en": ["shakshuka", "shakshouka"],
        "he": ["שקשוקה"]
      }
    },
    {
      "emoji": "🫗",
      "icon": "balsamic",
      "words": {
        "en": ["dressing", "ranch$", "thousand island", "salad cream"],
        "he": ["רוטב לסלט", "ויניגרט", "אלף האיים"]
      }
    },
    {
      "emoji": "🥗",
      "icon": "fruit-salad",
      "words": {
        "en": ["fruit salad", "mixed fruit", "fruit cup", "fruit bowl", "fruit mix"],
        "he": ["סלט פירות", "פירות חתוכים"]
      }
    },
    {
      "emoji": "🥗",
      "icon": "israeli-salad",
      "words": {
        "en": ["israeli salad", "chopped salad", "arab salad", "shirazi", "shepherd salad"],
        "he": ["סלט ישראלי", "סלט קצוץ", "סלט ערבי", "סלט ירקות"]
      }
    },
    {
      "emoji": "🥗",
      "icon": "tabbouleh",
      "words": {
        "en": ["tabbouleh", "tabouli", "tabouleh", "tabbouli"],
        "he": ["טבולה"]
      }
    },
    {
      "emoji": "🥗",
      "icon": "coleslaw",
      "words": {
        "en": ["coleslaw", "slaw"],
        "he": ["קולסלאו", "סלט כרוב"]
      }
    },
    {
      "emoji": "🥗",
      "words": {
        "en": ["salad"],
        "he": ["סלט"]
      }
    },
    {
      "emoji": "🍲",
      "words": {
        "en": [
          "soup",
          "stew",
          "broth",
          "goulash",
          "chowder",
          "bisque",
          "borscht",
          "gazpacho",
          "minestrone",
          "chili con carne",
          "chilli con carne",
          "cholent",
          "hamin",
          "casserole",
          "tagine",
          "ramen soup",
          "stock$",
          "stock cube"
        ],
        "he": ["מרק", "תבשיל", "חמין", "צ'ולנט", "ציר$", "גולאש", "בורשט", "גספצ'ו"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "lentils",
      "words": {
        "en": ["mujadara", "majadra", "mujaddara", "mejadra"],
        "he": ["מג'דרה", "מגדרה"]
      }
    },
    {
      "emoji": "🍛",
      "words": {
        "en": ["curry", "curries", "butter chicken"],
        "he": ["קארי"]
      }
    },
    {
      "emoji": "🍙",
      "words": {
        "en": ["onigiri", "rice ball"],
        "he": ["אוניגירי"]
      }
    },
    {
      "emoji": "🍣",
      "words": {
        "en": ["sushi"],
        "he": ["סושי"]
      }
    },
    {
      "emoji": "🍜",
      "icon": "rice-noodles",
      "words": {
        "en": ["rice noodle", "vermicelli", "glass noodle", "rice stick"],
        "he": ["אטריות אורז", "אטריות שעועית"]
      }
    },
    {
      "emoji": "🍜",
      "icon": "pad-thai",
      "words": {
        "en": ["pad thai", "phad thai", "lo mein", "chow mein", "yakisoba"],
        "he": ["פאד תאי", "פד תאי"]
      }
    },
    {
      "emoji": "🍜",
      "words": {
        "en": ["noodle", "ramen", "udon", "soba", "pho$"],
        "he": ["נודלס", "אטרי", "ראמן", "אודון", "סובה", "פו$"]
      }
    },
    {
      "emoji": "🍝",
      "icon": "penne",
      "words": {
        "en": [
          "penne",
          "fusilli",
          "rigatoni",
          "tortiglioni",
          "farfalle",
          "macaroni",
          "gemelli",
          "pappardelle",
          "tagliatelle",
          "fettuccine",
          "conchiglie",
          "orecchiette",
          "rotini",
          "rigati",
          "rigate"
        ],
        "he": ["פנה", "פוזילי", "פרפלה", "פפרדלה", "מקרוני", "ריגטוני"]
      }
    },
    {
      "emoji": "🍝",
      "words": {
        "en": ["pasta", "spaghetti"],
        "he": ["פסטה", "ספגטי"]
      }
    },
    {
      "emoji": "🥟",
      "icon": "gnocchi",
      "words": {
        "en": ["gnocchi"],
        "he": ["ניוקי"]
      }
    },
    {
      "emoji": "🥟",
      "icon": "ravioli",
      "words": {
        "en": ["ravioli", "tortellini", "agnolotti", "cappelletti"],
        "he": ["רביולי", "טורטליני"]
      }
    },
    {
      "emoji": "🍝",
      "icon": "lasagna",
      "words": {
        "en": ["lasagna", "lasagne"],
        "he": ["לזניה"]
      }
    },
    {
      "emoji": "🥟",
      "icon": "samosa",
      "words": {
        "en": ["samosa", "sambusak", "sambousek"],
        "he": ["סמבוסק", "סמבוסה"]
      }
    },
    {
      "emoji": "🥟",
      "icon": "spring-rolls",
      "words": {
        "en": ["spring roll", "egg roll", "eggroll"],
        "he": ["ספרינג רול", "אגרול"]
      }
    },
    {
      "emoji": "🥟",
      "words": {
        "en": [
          "dumpling",
          "empanada",
          "bao$",
          "gyoza",
          "dim sum",
          "pierogi",
          "wonton",
          "momo$",
          "dumplings"
        ],
        "he": ["כיסונ", "כופתאות", "אמפנדה", "גיוזה", "באו$", "פירוגי", "וונטון"]
      }
    },
    {
      "emoji": "🥧",
      "words": {
        "en": ["pie$", "pies$"],
        "he": ["פאי"]
      }
    },
    {
      "emoji": "🧁",
      "words": {
        "en": ["cupcake", "fairy cake"],
        "he": ["קאפקייק", "מאפינס"]
      }
    },
    {
      "emoji": "🍪",
      "icon": "wafers",
      "words": {
        "en": ["wafers$", "wafer biscuit", "wafer bar", "wafer roll"],
        "he": ["ופלים", "וופלים"]
      }
    },
    {
      "emoji": "🍪",
      "words": {
        "en": [
          "cookie",
          "biscuit",
          "shortbread",
          "gingerbread",
          "digestive",
          "graham",
          "macaron$",
          "macarons$",
          "macaroon",
          "snickerdoodle"
        ],
        "he": ["עוגי", "ביסקו", "ביסקוויט"]
      }
    },
    {
      "emoji": "🐟",
      "words": {
        "en": ["fish cake", "fishcake", "crab cake", "crabcake"]
      }
    },
    {
      "emoji": "🍰",
      "words": {
        "en": ["cake"],
        "he": ["עוג"]
      }
    },
    {
      "emoji": "🍩",
      "words": {
        "en": ["doughnut", "donut"],
        "he": ["סופגני"]
      }
    },
    {
      "emoji": "🍡",
      "icon": "ice-pop",
      "words": {
        "en": ["ice pop", "popsicle", "ice lolly", "ices tube", "freeze pop"],
        "he": ["ארטיק", "שלגון", "קרטיב"]
      }
    },
    {
      "emoji": "🍭",
      "words": {
        "en": ["lollipop", "chupa chups", "lolly"],
        "he": ["סוכריה על מקל", "לקקן"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "sour-cream",
      "words": {
        "en": ["coffee cream", "creamer", "coffee whitener"],
        "he": ["חלב לקפה"]
      }
    },
    {
      "emoji": "☕",
      "words": {
        "en": ["coffee", "espresso"],
        "he": ["קפה", "אספרסו", "נמס"]
      }
    },
    {
      "emoji": "🍵",
      "words": {
        "en": [
          "tea$",
          "teas$",
          "teabag",
          "matcha",
          "chai$",
          "rooibos",
          "chamomile",
          "earl grey",
          "green tea",
          "herbal tea",
          "infusion"
        ],
        "he": ["תה$", "מאצ'ה", "צ'אי", "קמומיל", "חליטה"]
      }
    },
    {
      "emoji": "🧃",
      "words": {
        "en": ["juice"],
        "he": ["מיץ"]
      }
    },
    {
      "emoji": "🥤",
      "words": {
        "en": ["smoothie", "shake", "milkshake"],
        "he": ["סמוז", "שייק", "מילקשייק"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "hummus",
      "words": {
        "en": ["hummus", "houmous", "humus"],
        "he": ["חומוס"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "chickpeas",
      "words": {
        "en": ["chickpea", "garbanzo"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "cauliflower",
      "words": {
        "en": ["cauliflower rice", "cauli rice"],
        "he": ["אורז כרובית"]
      }
    },
    {
      "emoji": "🎃",
      "icon": "butternut-squash",
      "words": {
        "en": ["butternut"]
      }
    },
    {
      "emoji": "⭐",
      "icon": "starfruit",
      "words": {
        "en": ["starfruit", "star fruit", "carambola"],
        "he": ["קרמבולה"]
      }
    },
    {
      "emoji": "🍈",
      "icon": "dragon-fruit",
      "words": {
        "en": ["dragon fruit", "dragonfruit", "pitaya", "pitahaya"],
        "he": ["פיטאיה", "פיטהיה"]
      }
    },
    {
      "emoji": "🍒",
      "icon": "cranberries",
      "words": {
        "en": ["cranberr", "lingonberr"],
        "he": ["חמוציות", "חמוציה"]
      }
    },
    {
      "emoji": "🥒",
      "icon": "zucchini",
      "words": {
        "en": ["zucchini", "courgette"],
        "he": ["קישוא"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "kefir",
      "words": {
        "en": [
          "kefir",
          "ayran",
          "yogurt drink",
          "yoghurt drink",
          "drinking yogurt",
          "lassi",
          "buttermilk"
        ],
        "he": ["קפיר", "אייראן", "יוגורט לשתייה", "משקה יוגורט", "רויון", "ריוויון"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "greek-yogurt",
      "words": {
        "en": ["greek yogurt", "greek yoghurt", "greek-style", "skyr"],
        "he": ["יוגורט יווני", "סקייר"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "labneh",
      "words": {
        "en": ["labneh", "labane", "labaneh", "labna"],
        "he": ["לאבנה"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "yogurt-cup",
      "words": {
        "en": [
          "yoghurt",
          "yogurt",
          "leben",
          "laban",
          "activia",
          "danone",
          "muller",
          "müller",
          "yoplait"
        ],
        "he": ["יוגורט", "אקטיביה", "דנונה", "יופלה", "מולר"],
        "fr": ["yaourt", "fromage blanc", "fromage frais"]
      }
    },
    {
      "emoji": "🍮",
      "icon": "pudding",
      "words": {
        "en": [
          "pudding",
          "custard",
          "panna cotta",
          "mousse",
          "flan$",
          "malabi",
          "creme brulee",
          "crème brûlée",
          "creme caramel",
          "jello"
        ],
        "he": ["פודינג", "מעדן", "מלבי", "מוס$", "פלאן"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "cocoa-powder",
      "words": {
        "en": ["cocoa", "cacao"],
        "he": ["קקאו"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "halva",
      "words": {
        "en": ["halva", "halwa", "halvah"],
        "he": ["חלבה"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "plant-milk",
      "words": {
        "en": [
          "soy milk",
          "soya milk",
          "almond milk",
          "oat milk",
          "rice milk",
          "coconut milk",
          "plant milk",
          "soy drink",
          "soya drink",
          "oat drink",
          "almond drink",
          "alpro",
          "almondmilk",
          "oatmilk",
          "soymilk",
          "coconutmilk",
          "oatly",
          "rice drink"
        ],
        "he": [
          "משקה סויה",
          "חלב סויה",
          "משקה שקדים",
          "חלב שקדים",
          "משקה שיבולת",
          "חלב שיבולת",
          "משקה אורז",
          "משקה צמחי",
          "אלפרו"
        ]
      }
    },
    {
      "emoji": "🧀",
      "icon": "cottage-cheese",
      "words": {
        "en": ["cottage", "tvorog"],
        "he": ["קוטג", "טבורוג"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "cream-cheese",
      "words": {
        "en": ["cream cheese", "philadelphia", "ricotta", "mascarpone", "quark"],
        "he": ["גבינת שמנת", "גבינה לבנה", "ריקוטה", "מסקרפונה", "פילדלפיה"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "feta",
      "words": {
        "en": ["feta", "bulgarian cheese", "bulgarit", "tzfatit", "paneer"],
        "he": ["פטה", "בולגרית", "צפתית", "פנאיר"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "halloumi",
      "words": {
        "en": ["halloumi", "hallumi"],
        "he": ["חלומי"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "mozzarella",
      "words": {
        "en": ["mozzarella", "burrata", "bocconcini"],
        "he": ["מוצרלה", "בוראטה"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "cheese-slices",
      "words": {
        "en": [
          "sliced cheese",
          "cheese slice",
          "yellow cheese",
          "emek",
          "gouda",
          "cheddar",
          "emmental",
          "swiss cheese",
          "provolone",
          "american cheese"
        ],
        "he": ["גבינה צהובה", "עמק", "גאודה", "צ'דר", "אמנטל", "פרובולונה"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "whipped-cream",
      "words": {
        "en": ["whipped cream", "whipping cream", "squirty cream"],
        "he": ["קצפת", "שמנת מתוקה"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "cheese-wedge",
      "words": {
        "en": [
          "cheese",
          "parmesan",
          "parmigiano",
          "pecorino",
          "grana padano",
          "manchego",
          "gruyere",
          "gruyère",
          "gorgonzola",
          "roquefort",
          "camembert"
        ],
        "he": ["גבינ", "פרמזן", "פקורינו", "גורגונזולה", "קממבר"]
      }
    },
    {
      "emoji": "🥛",
      "words": {
        "en": ["milk"],
        "he": ["חלב"]
      }
    },
    {
      "emoji": "🥛",
      "words": {
        "en": [
          "sour cream",
          "cooking cream",
          "creme fraiche",
          "crème fraîche",
          "heavy cream",
          "double cream",
          "single cream",
          "cream$",
          "creams$"
        ],
        "he": ["שמנת"]
      },
      "icon": "sour-cream"
    },
    {
      "emoji": "🥜",
      "icon": "peanut-butter",
      "words": {
        "en": ["peanut butter"],
        "he": ["חמאת בוטנים"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "almond-butter",
      "words": {
        "en": ["almond butter", "cashew butter", "nut butter"],
        "he": ["חמאת שקדים", "חמאת קשיו", "חמאת אגוזים"]
      }
    },
    {
      "emoji": "🧈",
      "words": {
        "en": ["butter", "ghee"],
        "he": ["חמא", "גהי"]
      }
    },
    {
      "emoji": "🥚",
      "icon": "boiled-egg",
      "words": {
        "en": ["boiled egg", "hard boiled", "soft boiled", "deviled egg"],
        "he": ["ביצה קשה", "ביצים קשות", "ביצה רכה", "ביצים רכות", "ביצה מבושלת", "ביצים מבושלות"]
      }
    },
    {
      "emoji": "🍳",
      "icon": "scrambled-eggs",
      "words": {
        "en": ["scrambled"],
        "he": ["מקושקש"]
      }
    },
    {
      "emoji": "🍳",
      "words": {
        "en": ["fried egg", "poached egg", "sunny side", "over easy", "egg in a basket"],
        "he": ["ביצת עין", "ביצה עלומה", "ביצה מטוגנת", "ביצים מטוגנות"]
      }
    },
    {
      "emoji": "🥚",
      "words": {
        "en": ["egg"],
        "he": ["ביצ"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "chicken-nuggets",
      "words": {
        "en": [
          "nugget",
          "chicken finger",
          "chicken tender",
          "fish finger",
          "fish stick",
          "goujon",
          "popcorn chicken"
        ],
        "he": ["נאגטס", "שניצלונים", "אצבעות דג", "אצבעות עוף"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "schnitzel",
      "words": {
        "en": ["schnitzel", "cutlet", "breaded"],
        "he": ["שניצל"]
      }
    },
    {
      "emoji": "🥩",
      "icon": "meatballs",
      "words": {
        "en": ["meatball", "kofta", "kufta"],
        "he": ["קציצ", "כדורי בשר"]
      }
    },
    {
      "emoji": "🥩",
      "icon": "ground-beef",
      "words": {
        "en": [
          "ground beef",
          "minced beef",
          "mince",
          "ground meat",
          "ground turkey",
          "ground chicken"
        ],
        "he": ["בשר טחון", "טחון"]
      }
    },
    {
      "emoji": "🥓",
      "icon": "deli-slices",
      "words": {
        "en": [
          "deli meat",
          "deli slice",
          "deli turkey",
          "cold cut",
          "sliced turkey",
          "turkey slices",
          "turkey breast slices",
          "pastrami",
          "corned beef",
          "spam$",
          "luncheon meat",
          "roast beef"
        ],
        "he": ["פסטרמה", "נקניק הודו", "פרוסות הודו", "רוסטביף", "קורנביף"]
      }
    },
    {
      "emoji": "🍢",
      "icon": "kebab",
      "words": {
        "en": ["kebab", "kabab", "skewer", "shish", "souvlaki", "satay", "yakitori"],
        "he": ["קבב", "שיפוד"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "roast-chicken",
      "words": {
        "en": ["roast chicken", "whole chicken", "rotisserie", "chicken roast"],
        "he": ["עוף צלוי", "עוף שלם", "עוף בגריל", "עוף ממולא"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "chicken-wings",
      "words": {
        "en": ["chicken wing", "wings", "buffalo wing"],
        "he": ["כנפיים", "כנפי עוף", "כנף"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "chicken-breast",
      "words": {
        "en": ["chicken breast", "chicken fillet", "turkey breast"],
        "he": ["חזה עוף", "פילה עוף", "חזה הודו"]
      }
    },
    {
      "emoji": "🌭",
      "icon": "sausages",
      "words": {
        "en": ["sausage", "frankfurter", "franks$", "frank$", "wiener", "bratwurst", "kielbasa"],
        "he": ["נקניק", "מרגז"]
      }
    },
    {
      "emoji": "🍗",
      "icon": "chicken-thighs",
      "words": {
        "en": ["chicken thigh", "boneless thigh", "thigh fillet", "thigh$", "thighs$"],
        "he": ["פרגית", "פרגיות", "ירך עוף", "ירכי עוף"]
      }
    },
    {
      "emoji": "💊",
      "icon": "vitamins",
      "words": {
        "en": [
          "vitamin",
          "multivitamin",
          "supplement",
          "omega",
          "fish oil",
          "cod liver",
          "capsule",
          "magnesium",
          "zinc",
          "probiotic",
          "calcium",
          "iron$"
        ],
        "he": [
          "ויטמין",
          "אומגה",
          "תוסף$",
          "כמוסות",
          "מגנזיום",
          "אבץ",
          "ברזל",
          "פרוביוטיקה",
          "סידן",
          "תוספי תזונה"
        ]
      }
    },
    {
      "emoji": "🥩",
      "icon": "liver",
      "words": {
        "en": ["liver$", "livers$", "chicken liver", "pate$", "pâté"],
        "he": ["כבד$", "כבדי עוף", "כבד עוף"]
      }
    },
    {
      "emoji": "🍗",
      "words": {
        "en": ["chicken", "drumstick", "fried chicken"],
        "he": ["עוף", "שוקיים", "כרעיים"]
      }
    },
    {
      "emoji": "🍗",
      "words": {
        "en": ["turkey", "duck"],
        "he": ["הודו", "ברווז"]
      }
    },
    {
      "emoji": "🥩",
      "icon": "jerky",
      "words": {
        "en": ["jerky", "biltong", "dried meat"],
        "he": ["ג'רקי", "בשר מיובש"]
      }
    },
    {
      "emoji": "🍖",
      "words": {
        "en": [
          "rib$",
          "ribs$",
          "spare rib",
          "short rib",
          "brisket",
          "asado",
          "pulled pork",
          "lamb chop",
          "osso buco"
        ],
        "he": ["צלעות", "אסאדו", "שפונדרה", "צלע$"]
      }
    },
    {
      "emoji": "🥩",
      "words": {
        "en": ["steak", "beef", "lamb"],
        "he": ["סטייק", "בקר", "בשר", "כבש", "טלה"]
      }
    },
    {
      "emoji": "🍕",
      "icon": "salami",
      "words": {
        "en": ["salami", "pepperoni", "chorizo", "kabanos"],
        "he": ["סלמי", "פפרוני", "קבנוס"]
      }
    },
    {
      "emoji": "🥓",
      "words": {
        "en": ["pork", "bacon", "ham$", "hams$"],
        "he": ["חזיר", "בייקון"]
      }
    },
    {
      "emoji": "🌭",
      "words": {
        "en": ["hot dog", "corn dog"]
      }
    },
    {
      "emoji": "🍶",
      "icon": "soy-sauce",
      "words": {
        "en": ["fish sauce", "oyster sauce", "hoisin", "worcestershire", "ponzu"],
        "he": ["רוטב דגים", "רוטב צדפות", "הויסין", "ווסטרשייר"]
      }
    },
    {
      "emoji": "🐟",
      "icon": "smoked-salmon",
      "words": {
        "en": ["smoked salmon", "lox", "gravlax", "smoked trout"],
        "he": ["סלמון מעושן", "דג מעושן"]
      }
    },
    {
      "emoji": "🐟",
      "icon": "salmon",
      "words": {
        "en": ["salmon", "trout"],
        "he": ["סלמון", "פורל", "טרוטה"]
      }
    },
    {
      "emoji": "🐟",
      "icon": "canned-tuna",
      "words": {
        "en": ["tuna"],
        "he": ["טונה"]
      }
    },
    {
      "emoji": "🐟",
      "icon": "sardines",
      "words": {
        "en": ["sardine", "anchov", "mackerel", "herring"],
        "he": ["סרדינ", "אנשובי", "מקרל", "הרינג"]
      }
    },
    {
      "emoji": "🐟",
      "icon": "fish-fillet",
      "words": {
        "en": [
          "fish fillet",
          "cod",
          "tilapia",
          "sea bass",
          "sea bream",
          "barramundi",
          "white fish",
          "pollock",
          "haddock"
        ],
        "he": ["פילה דג", "אמנון", "מושט", "בקלה", "דניס", "לברק", "הייק", "נסיכת הנילוס"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "sourdough",
      "words": {
        "en": ["sourdough", "artisan", "country loaf"],
        "he": ["מחמצת", "לחם כפרי", "כיכר לחם"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "wholegrain-bread",
      "words": {
        "en": [
          "whole wheat bread",
          "wholewheat bread",
          "whole grain bread",
          "wholegrain bread",
          "multigrain bread",
          "wholemeal bread",
          "brown bread",
          "rye bread",
          "sliced bread",
          "bread slice",
          "slice of bread",
          "pumpernickel",
          "shiphon"
        ],
        "he": [
          "לחם מלא",
          "לחם דגנים",
          "לחם שיפון",
          "לחם קל",
          "לחם כוסמין",
          "פרוסת לחם",
          "פרוסות לחם"
        ]
      }
    },
    {
      "emoji": "🥣",
      "icon": "granola-bar",
      "words": {
        "en": ["granola bar", "cereal bar", "muesli bar", "oat bar", "flapjack"],
        "he": ["חטיף דגנים", "חטיף גרנולה", "חטיף שיבולת"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "cereal-box",
      "words": {
        "en": ["cereal", "cornflakes", "corn flakes", "bran flakes", "cheerios"],
        "he": ["דגני", "קורנפלקס"]
      }
    },
    {
      "emoji": "🦀",
      "words": {
        "en": ["crab", "surimi", "kani"],
        "he": ["סורימי", "סרטן", "קאני"]
      }
    },
    {
      "emoji": "🦞",
      "words": {
        "en": ["lobster", "crayfish", "langoustine"],
        "he": ["לובסטר"]
      }
    },
    {
      "emoji": "🦑",
      "words": {
        "en": ["squid", "calamari", "octopus", "cuttlefish"],
        "he": ["קלמרי", "דיונון", "תמנון"]
      }
    },
    {
      "emoji": "🦪",
      "words": {
        "en": ["oyster", "mussel", "clam$", "clams$", "scallop$", "seafood", "scallops$"],
        "he": ["צדפ", "מולים", "פירות ים"]
      }
    },
    {
      "emoji": "🐟",
      "words": {
        "en": ["fish"],
        "he": ["דג"]
      }
    },
    {
      "emoji": "🦐",
      "words": {
        "en": ["prawn", "shrimp"],
        "he": ["שרימפס", "חסילונ"]
      }
    },
    {
      "emoji": "🍚",
      "words": {
        "en": ["rice", "basmati", "risotto", "pilaf", "pilau", "jasmine rice"],
        "he": ["אורז", "באסמטי", "ריזוטו", "פילאף"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "pearl-couscous",
      "words": {
        "en": ["pearl couscous", "israeli couscous", "giant couscous", "ptitim"],
        "he": ["פתיתים", "פתיתי"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "couscous",
      "words": {
        "en": ["couscous", "kuskus"],
        "he": ["קוסקוס"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "bulgur",
      "words": {
        "en": [
          "bulgur",
          "bulghur",
          "burghul",
          "freekeh",
          "barley",
          "farro",
          "millet",
          "sorghum",
          "amaranth"
        ],
        "he": ["בורגול", "גריסים", "דוחן"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "buckwheat",
      "words": {
        "en": ["buckwheat", "kasha"],
        "he": ["כוסמת"]
      }
    },
    {
      "emoji": "🍚",
      "icon": "quinoa",
      "words": {
        "en": ["quinoa"],
        "he": ["קינואה"]
      }
    },
    {
      "emoji": "🍪",
      "icon": "crackers",
      "words": {
        "en": ["cracker", "saltine", "crispbread"],
        "he": ["קרקר"]
      }
    },
    {
      "emoji": "🫓",
      "icon": "pita",
      "words": {
        "en": ["pita", "pitta", "pitot"],
        "he": ["פיתה", "פיתות"]
      }
    },
    {
      "emoji": "🫓",
      "words": {
        "en": ["naan", "lavash", "laffa", "flatbread", "flat bread"],
        "he": ["לאפה", "נאן", "לחם שטוח"]
      }
    },
    {
      "emoji": "🍞",
      "words": {
        "en": ["bread", "crouton"],
        "he": ["לחם", "קרוטון"]
      }
    },
    {
      "emoji": "🫓",
      "icon": "malawach",
      "words": {
        "en": ["malawach", "malawah", "paratha", "lachuch"],
        "he": ["מלאווח", "מלוואח", "מלאוח"]
      }
    },
    {
      "emoji": "🫓",
      "icon": "jachnun",
      "words": {
        "en": ["jachnun", "kubaneh"],
        "he": ["ג'חנון", "גחנון", "כובנה"]
      }
    },
    {
      "emoji": "🥨",
      "words": {
        "he": ["בייגלה"]
      }
    },
    {
      "emoji": "🥯",
      "words": {
        "en": ["bagel"],
        "he": ["בייגל"]
      }
    },
    {
      "emoji": "🥐",
      "icon": "filo",
      "words": {
        "en": [
          "filo",
          "phyllo",
          "pastry leaves",
          "pastry sheet",
          "puff pastry",
          "baklava",
          "baklawa",
          "kadaif",
          "kataifi"
        ],
        "he": ["בצק עלים", "עלי בצק", "פילו", "בקלאווה", "בקלאוה", "קדאיף"]
      }
    },
    {
      "emoji": "🥐",
      "icon": "rugelach",
      "words": {
        "en": ["rugelach", "rugala", "rogelach"],
        "he": ["רוגלך", "רוגעלך"]
      }
    },
    {
      "emoji": "🥐",
      "words": {
        "en": [
          "croissant",
          "danish$",
          "danishes",
          "pastry$",
          "pastries",
          "strudel",
          "turnover",
          "pain au chocolat",
          "pains au chocolat"
        ],
        "he": ["קרואסון", "מאפה", "מאפים", "שטרודל"]
      }
    },
    {
      "emoji": "🥖",
      "words": {
        "en": ["baguette"],
        "he": ["באגט"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "focaccia",
      "words": {
        "en": ["focaccia", "ciabatta"],
        "he": ["פוקאצ'ה", "פוקצ'ה", "פוקאצה", "צ'יאבטה"]
      }
    },
    {
      "emoji": "🧁",
      "icon": "english-muffin",
      "words": {
        "en": ["english muffin", "crumpet", "scone"],
        "he": ["סקונס"]
      }
    },
    {
      "emoji": "🍞",
      "icon": "challah",
      "words": {
        "en": ["challah", "hallah"],
        "he": ["חלה"]
      }
    },
    {
      "emoji": "🫓",
      "icon": "matzah",
      "words": {
        "en": ["matzah", "matza", "matzo"],
        "he": ["מצה", "מצות"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "pralines",
      "words": {
        "en": ["praline", "truffle", "bonbon", "ferrero", "baci", "lindor", "raffaello"],
        "he": ["פרלין", "טראפל", "בונבוניר"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "krembo",
      "words": {
        "en": ["krembo", "mallomar", "teacake"],
        "he": ["קרמבו"]
      }
    },
    {
      "emoji": "🍫",
      "icon": "brownie",
      "words": {
        "en": ["brownie", "blondie"],
        "he": ["בראוני"]
      }
    },
    {
      "emoji": "🍰",
      "icon": "tiramisu",
      "words": {
        "en": ["tiramisu"],
        "he": ["טירמיסו"]
      }
    },
    {
      "emoji": "🧁",
      "icon": "muffin",
      "words": {
        "en": ["muffin"],
        "he": ["מאפין"]
      }
    },
    {
      "emoji": "🥞",
      "icon": "crepe",
      "words": {
        "en": ["crepe", "crêpe", "blintz"],
        "he": ["קרפ", "בלינצ'ס"]
      }
    },
    {
      "emoji": "🥞",
      "words": {
        "en": ["pancake"],
        "he": ["פנקייק"]
      }
    },
    {
      "emoji": "🧇",
      "words": {
        "en": ["waffle"],
        "he": ["וופל"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "overnight-oats",
      "words": {
        "en": ["overnight oat"]
      }
    },
    {
      "emoji": "🥣",
      "words": {
        "en": ["porridge", "oatmeal", "granola", "muesli"],
        "he": ["דייסה", "גרנולה"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "oats",
      "words": {
        "en": ["oat", "quaker"],
        "he": ["שיבולת", "קוואקר", "קווקר"]
      }
    },
    {
      "emoji": "🍟",
      "icon": "potato-chips",
      "words": {
        "en": [
          "crisps",
          "potato chips",
          "tortilla chips",
          "doritos",
          "pringles",
          "nachos",
          "bissli",
          "veggie straws",
          "pretzel crisps"
        ],
        "he": ["תפוצ'יפס", "תפוציפס", "דוריטוס", "ביסלי"]
      }
    },
    {
      "emoji": "🫓",
      "icon": "tortillas",
      "words": {
        "en": ["tortilla"],
        "he": ["טורטי"]
      }
    },
    {
      "emoji": "🫑",
      "icon": "stuffed-peppers",
      "words": {
        "en": ["stuffed pepper", "stuffed vegetable", "dolma", "stuffed grape"],
        "he": ["פלפל ממולא", "פלפלים ממולאים", "ממולא", "עלי גפן"]
      }
    },
    {
      "emoji": "🥔",
      "icon": "mashed-potatoes",
      "words": {
        "en": ["mash$", "mashed", "mashed potato", "potato puree", "colcannon"],
        "he": ["פירה", "מחית תפוחי אדמה"]
      }
    },
    {
      "emoji": "🍠",
      "words": {
        "en": ["sweet potato", "yam$", "yams$", "cassava", "taro$", "manioc"],
        "he": ["בטטה", "קסאווה", "טארו"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "peanut-puffs",
      "words": {
        "en": ["bamba", "peanut puff"],
        "he": ["במבה"]
      }
    },
    {
      "emoji": "🥔",
      "words": {
        "en": ["potato", "hash brown", "rosti", "wedges", "potato wedge"],
        "he": ["תפוח אדמה", "תפו\"א", "רוסטי", "תפוחי אדמה"]
      }
    },
    {
      "emoji": "🍟",
      "words": {
        "en": ["chips", "fries"],
        "he": ["צ'יפס", "ציפס"]
      }
    },
    {
      "emoji": "🍅",
      "icon": "ketchup",
      "words": {
        "en": ["ketchup", "catsup"],
        "he": ["קטשופ"]
      }
    },
    {
      "emoji": "🌭",
      "icon": "mustard",
      "words": {
        "en": ["mustard", "dijon"],
        "he": ["חרדל"]
      }
    },
    {
      "emoji": "🥚",
      "icon": "mayonnaise",
      "words": {
        "en": ["mayo", "aioli"],
        "he": ["מיונז", "איולי"]
      }
    },
    {
      "emoji": "🌶️",
      "icon": "hot-sauce",
      "words": {
        "en": [
          "hot sauce",
          "sriracha",
          "tabasco",
          "chili sauce",
          "chilli sauce",
          "harissa",
          "schug",
          "zhug"
        ],
        "he": ["סריראצ'ה", "סרירצה", "רוטב חריף", "רוטב צ'ילי", "הריסה", "סחוג", "סחוק"]
      }
    },
    {
      "emoji": "🍖",
      "icon": "bbq-sauce",
      "words": {
        "en": ["bbq", "barbecue", "barbeque"],
        "he": ["ברביקיו"]
      }
    },
    {
      "emoji": "🍶",
      "icon": "soy-sauce",
      "words": {
        "en": ["soy sauce", "soya sauce", "shoyu", "tamari", "teriyaki", "taryaki", "kikkoman"],
        "he": ["רוטב סויה", "טריאקי", "טרייאקי", "קיקומן"],
        "fr": ["sauce soja"]
      }
    },
    {
      "emoji": "🌿",
      "icon": "pesto",
      "words": {
        "en": ["pesto"],
        "he": ["פסטו"]
      }
    },
    {
      "emoji": "🍅",
      "icon": "salsa",
      "words": {
        "en": ["salsa", "pico de gallo"],
        "he": ["סלסה"]
      }
    },
    {
      "emoji": "🫗",
      "icon": "balsamic",
      "words": {
        "en": ["balsamic", "vinegar", "vinaigrette"],
        "he": ["בלסמי", "חומץ"]
      }
    },
    {
      "emoji": "🫗",
      "icon": "cooking-spray",
      "words": {
        "en": ["cooking spray", "oil spray", "spray oil", "fry light", "frylight", "spray"],
        "he": ["ספריי שמן", "שמן בספריי"]
      }
    },
    {
      "emoji": "🫒",
      "icon": "olive-oil",
      "words": {
        "en": ["olive oil", "evoo", "extra virgin"],
        "he": ["שמן זית"]
      }
    },
    {
      "emoji": "🫗",
      "words": {
        "en": [
          "vegetable oil",
          "canola",
          "rapeseed oil",
          "sunflower oil",
          "coconut oil",
          "avocado oil",
          "sesame oil",
          "peanut oil",
          "frying oil"
        ],
        "he": ["שמן קנולה", "שמן חמניות", "שמן קוקוס", "שמן אבוקדו", "שמן שומשום", "שמן צמחי"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "tahini",
      "words": {
        "en": ["tahini", "tahina", "thini", "tehina", "sesame paste"],
        "he": ["טחינה"]
      }
    },
    {
      "emoji": "🍯",
      "icon": "maple-syrup",
      "words": {
        "en": ["syrup", "maple", "silan", "date syrup", "agave", "molasses", "treacle"],
        "he": ["סירופ", "סילאן", "מייפל", "דבש תמרים", "אגבה"]
      }
    },
    {
      "emoji": "🍓",
      "icon": "jam",
      "words": {
        "en": ["jam", "marmalade", "preserve", "confiture", "fruit spread", "jelly$", "jellies$"],
        "he": ["ריבה", "קונפיטורה", "מרמלדה", "ממרח פירות", "ג'לי"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "kimchi",
      "words": {
        "en": ["kimchi", "sauerkraut", "kraut", "fermented cabbage"],
        "he": ["קימצ'י", "כרוב כבוש", "כרוב חמוץ"]
      }
    },
    {
      "emoji": "🥒",
      "icon": "pickles",
      "words": {
        "en": ["pickle", "gherkin", "cornichon", "dill pickle", "dill spear"],
        "he": ["מלפפון חמוץ", "חמוצ"]
      }
    },
    {
      "emoji": "🥑",
      "icon": "guacamole",
      "words": {
        "en": ["guacamole", "guac"],
        "he": ["גוואקמולי", "גואקמולי", "ממרח אבוקדו"]
      }
    },
    {
      "emoji": "🥒",
      "icon": "tzatziki",
      "words": {
        "en": ["tzatziki", "raita", "cacik"],
        "he": ["צזיקי", "זזיקי"]
      }
    },
    {
      "emoji": "🍅",
      "icon": "matbucha",
      "words": {
        "en": ["matbucha", "matboucha"],
        "he": ["מטבוחה", "מטבוכה"]
      }
    },
    {
      "emoji": "🧂",
      "icon": "spices",
      "words": {
        "en": [
          "spice",
          "seasoning",
          "paprika",
          "cumin",
          "turmeric",
          "za'atar",
          "zaatar",
          "baking powder",
          "baking soda",
          "bicarbonate",
          "yeast",
          "nutmeg",
          "oregano",
          "black pepper",
          "chili flakes",
          "garam masala",
          "ras el hanout",
          "sumac",
          "cinnamon",
          "peppercorn",
          "cardamom",
          "clove$",
          "cloves$",
          "chilli flakes"
        ],
        "he": [
          "תבלין",
          "פפריקה",
          "כמון",
          "כורכום",
          "קינמון",
          "זעתר",
          "בהרט",
          "אבקת אפייה",
          "סודה לשתייה",
          "שמרים",
          "פלפל שחור",
          "סומק",
          "אורגנו",
          "אגוז מוסקט",
          "הל$",
          "ציפורן"
        ]
      }
    },
    {
      "emoji": "🍦",
      "icon": "vanilla",
      "words": {
        "en": [
          "vanilla extract",
          "vanilla bean",
          "vanilla pod",
          "vanilla essence",
          "vanilla paste",
          "vanillin"
        ],
        "he": ["תמצית וניל", "מקל וניל", "סוכר וניל", "תמצית"]
      }
    },
    {
      "emoji": "🌾",
      "icon": "flour",
      "words": {
        "en": ["flour", "cornstarch", "corn starch", "semolina"],
        "he": ["קמח", "קורנפלור", "עמילן", "סולת"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "sweetener",
      "words": {
        "en": [
          "sweetener",
          "stevia",
          "sucralose",
          "splenda",
          "erythritol",
          "aspartame",
          "saccharin",
          "monk fruit",
          "xylitol"
        ],
        "he": ["ממתיק", "סטיביה", "סוכרלוז", "סוכרזית", "אריתריטול"]
      }
    },
    {
      "emoji": "🫛",
      "icon": "edamame",
      "words": {
        "en": ["edamame", "soybean", "soy bean", "soya bean"],
        "he": ["אדממה", "אדמאמה", "פולי סויה"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "soy-chunks",
      "words": {
        "en": ["textured soy", "soy chunk", "soya chunk", "soy protein", "tvp", "seitan"],
        "he": ["סויה מפורקת", "נתחי סויה", "גרגירי סויה", "סייטן", "סויה"]
      }
    },
    {
      "emoji": "🫛",
      "icon": "green-beans",
      "words": {
        "en": ["green bean", "string bean", "french bean", "haricot"],
        "he": ["שעועית ירוקה", "שעועית צהובה"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "black-beans",
      "words": {
        "en": ["black bean"],
        "he": ["שעועית שחורה"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "baked-beans",
      "words": {
        "en": ["baked bean", "beans in tomato"],
        "he": ["שעועית אפויה", "שעועית ברוטב", "שעועית לבנה ברוטב"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "brussels-sprouts",
      "words": {
        "en": ["brussels", "brussel sprout"],
        "he": ["כרוב ניצנים"]
      }
    },
    {
      "emoji": "🌱",
      "icon": "bean-sprouts",
      "words": {
        "en": ["sprout", "alfalfa"],
        "he": ["נבט"]
      }
    },
    {
      "emoji": "🥦",
      "icon": "frozen-vegetables",
      "words": {
        "en": [
          "frozen vegetable",
          "frozen veg",
          "mixed vegetable",
          "vegetable mix",
          "peas and carrots"
        ],
        "he": ["ירקות מוקפא", "ירקות קפוא", "לקט ירקות", "מעורב ירקות"]
      }
    },
    {
      "emoji": "🥦",
      "icon": "roasted-vegetables",
      "words": {
        "en": ["roasted veg", "roast veg", "grilled veg", "baked vegetable", "ratatouille"],
        "he": ["ירקות צלויים", "ירקות בתנור", "ירקות אפויים", "ירקות קלויים", "רטטוי"]
      }
    },
    {
      "emoji": "🧊",
      "icon": "tofu",
      "words": {
        "en": ["tofu"],
        "he": ["טופו"]
      }
    },
    {
      "emoji": "🧊",
      "icon": "tempeh",
      "words": {
        "en": ["tempeh"],
        "he": ["טמפה"]
      }
    },
    {
      "emoji": "🍙",
      "icon": "nori",
      "words": {
        "en": ["nori", "seaweed", "kelp", "wakame"],
        "he": ["אצות", "אצה", "נורי"]
      }
    },
    {
      "emoji": "🫘",
      "icon": "lentils",
      "words": {
        "en": ["lentil", "dhal", "daal"],
        "he": ["עדש"]
      }
    },
    {
      "emoji": "🫘",
      "words": {
        "en": ["bean"],
        "he": ["שעועית"]
      }
    },
    {
      "emoji": "🫛",
      "words": {
        "en": ["green pea", "snow pea", "sugar snap", "garden pea", "split pea", "peas"],
        "he": ["אפונה"]
      }
    },
    {
      "emoji": "🎃",
      "icon": "pumpkin-seeds",
      "words": {
        "en": ["pumpkin seed", "pepitas"],
        "he": ["גרעיני דלעת"]
      }
    },
    {
      "emoji": "🌾",
      "icon": "flaxseeds",
      "words": {
        "en": ["flax", "linseed"],
        "he": ["פשתן"]
      }
    },
    {
      "emoji": "🌾",
      "icon": "sesame-seeds",
      "words": {
        "en": ["sesame"],
        "he": ["שומשום"]
      }
    },
    {
      "emoji": "🌾",
      "icon": "chia-seeds",
      "words": {
        "en": ["chia"],
        "he": ["צ'יה"]
      }
    },
    {
      "emoji": "🌻",
      "icon": "sunflower-seeds",
      "words": {
        "en": ["sunflower", "multiseed", "multi-seed"],
        "he": ["גרעיני", "זרעי", "גרעינים"]
      }
    },
    {
      "emoji": "🍿",
      "words": {
        "en": ["popcorn"],
        "he": ["פופקורן"]
      }
    },
    {
      "emoji": "🌽",
      "words": {
        "en": ["corn", "sweetcorn", "corn on the cob"],
        "he": ["תירס"]
      }
    },
    {
      "emoji": "🥕",
      "words": {
        "en": ["carrot", "parsnip"],
        "he": ["גזר", "פסטינק"]
      }
    },
    {
      "emoji": "🥦",
      "words": {
        "en": ["broccoli"],
        "he": ["ברוקולי"]
      }
    },
    {
      "emoji": "🍅",
      "words": {
        "en": ["tomato"],
        "he": ["עגבני"]
      }
    },
    {
      "emoji": "🥒",
      "words": {
        "en": ["cucumber"],
        "he": ["מלפפון"]
      }
    },
    {
      "emoji": "🧅",
      "icon": "spring-onions",
      "words": {
        "en": ["spring onion", "green onion", "scallion", "chive"],
        "he": ["בצל ירוק", "עירית"]
      }
    },
    {
      "emoji": "🧅",
      "words": {
        "en": ["onion", "shallot"],
        "he": ["בצל", "שאלוט"]
      }
    },
    {
      "emoji": "🌿",
      "icon": "fennel",
      "words": {
        "en": ["fennel"],
        "he": ["שומר"]
      }
    },
    {
      "emoji": "🧄",
      "words": {
        "en": ["garlic"],
        "he": ["שום כתוש", "שן שום", "שיני שום", "ראש שום", "שום טרי", "אבקת שום", "שום קלוי"]
      }
    },
    {
      "emoji": "🌶️",
      "words": {
        "en": [
          "jalapeno",
          "jalapeño",
          "chili pepper",
          "chilli pepper",
          "chile$",
          "chili$",
          "chilli$",
          "habanero",
          "cayenne",
          "chilies$",
          "chillies$"
        ],
        "he": ["חלפיניו", "חלפניו", "פלפל חריף", "צ'ילי"]
      }
    },
    {
      "emoji": "🫑",
      "words": {
        "en": ["pepper"],
        "he": ["פלפל"]
      }
    },
    {
      "emoji": "🍄",
      "words": {
        "en": ["mushroom"],
        "he": ["פטרי"]
      },
      "icon": "mushrooms"
    },
    {
      "emoji": "🥑",
      "words": {
        "en": ["avocado"],
        "he": ["אבוקדו"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "red-cabbage",
      "words": {
        "en": ["red cabbage", "purple cabbage"],
        "he": ["כרוב סגול", "כרוב אדום"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "bok-choy",
      "words": {
        "en": ["bok choy", "bok choi", "pak choi", "pak choy", "chinese cabbage", "napa cabbage"],
        "he": ["באק צ'וי", "פאק צ'וי", "כרוב סיני"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "cauliflower",
      "words": {
        "en": ["cauliflower"],
        "he": ["כרובית"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "kohlrabi",
      "words": {
        "en": ["kohlrabi"],
        "he": ["קולרבי"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "cabbage",
      "words": {
        "en": ["cabbage"],
        "he": ["כרוב"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "arugula",
      "words": {
        "en": ["arugula", "rocket", "roquette"],
        "he": ["רוקט", "רוקולה", "ארוגולה"]
      }
    },
    {
      "emoji": "🥬",
      "words": {
        "en": [
          "lettuce",
          "spinach",
          "kale",
          "chard",
          "watercress",
          "endive",
          "radicchio",
          "romaine",
          "iceberg",
          "mixed leaves",
          "collard"
        ],
        "he": ["חסה", "תרד", "קייל", "מנגולד", "עולש", "רדיקיו", "עלי בייבי"]
      }
    },
    {
      "emoji": "🫛",
      "icon": "okra",
      "words": {
        "en": ["okra", "bamia"],
        "he": ["במיה"]
      }
    },
    {
      "emoji": "🌶️",
      "icon": "radish",
      "words": {
        "en": ["radish", "turnip"],
        "he": ["צנון", "לפת"]
      }
    },
    {
      "emoji": "🍠",
      "icon": "beetroot",
      "words": {
        "en": ["beet"],
        "he": ["סלק"]
      }
    },
    {
      "emoji": "🎃",
      "icon": "butternut-squash",
      "words": {
        "en": ["squash", "pumpkin"],
        "he": ["דלעת", "דלורית"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "celery",
      "words": {
        "en": ["celery"],
        "he": ["סלרי"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "asparagus",
      "words": {
        "en": ["asparagus"],
        "he": ["אספרגוס"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "artichoke",
      "words": {
        "en": ["artichoke"],
        "he": ["ארטישוק"]
      }
    },
    {
      "emoji": "🥬",
      "icon": "leek",
      "words": {
        "en": ["leek"],
        "he": ["כרשה"]
      }
    },
    {
      "emoji": "🥦",
      "words": {
        "en": ["vegetable", "veggie"],
        "he": ["ירקות", "ירק$"]
      }
    },
    {
      "emoji": "🍊",
      "icon": "grapefruit",
      "words": {
        "en": ["grapefruit", "pomelo"],
        "he": ["אשכולית", "פומלה"]
      }
    },
    {
      "emoji": "🍎",
      "icon": "pomegranate",
      "words": {
        "en": ["pomegranate"],
        "he": ["רימון"]
      }
    },
    {
      "emoji": "🍑",
      "icon": "dried-apricots",
      "words": {
        "en": ["dried apricot"],
        "he": ["משמש מיובש", "משמשים מיובשים", "מישמש מיובש"]
      }
    },
    {
      "emoji": "🍑",
      "icon": "apricot",
      "words": {
        "en": ["apricot"],
        "he": ["משמש", "מישמש"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "prunes",
      "words": {
        "en": ["prune", "dried plum"],
        "he": ["שזיפים מיובשים", "שזיף מיובש", "פרונס"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "plum",
      "words": {
        "en": ["plum"],
        "he": ["שזיף"]
      }
    },
    {
      "emoji": "🍊",
      "icon": "persimmon",
      "words": {
        "en": ["persimmon", "sharon fruit", "kaki"],
        "he": ["אפרסמון"]
      }
    },
    {
      "emoji": "🍈",
      "icon": "passion-fruit",
      "words": {
        "en": ["passion fruit", "passionfruit", "maracuya"],
        "he": ["פסיפלורה"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "mulberries",
      "words": {
        "en": ["mulberr"],
        "he": ["תות עץ"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "blackberries",
      "words": {
        "en": ["blackberr"],
        "he": ["פטל שחור"]
      }
    },
    {
      "emoji": "🍓",
      "icon": "raspberries",
      "words": {
        "en": ["raspberr"],
        "he": ["פטל"]
      }
    },
    {
      "emoji": "🍒",
      "icon": "lychees",
      "words": {
        "en": ["lychee", "litchi", "lichi", "rambutan"],
        "he": ["ליצ'י"]
      }
    },
    {
      "emoji": "🌵",
      "icon": "prickly-pear",
      "words": {
        "en": ["prickly pear", "cactus pear", "sabra"],
        "he": ["סברס", "צבר"]
      }
    },
    {
      "emoji": "🍑",
      "icon": "loquats",
      "words": {
        "en": ["loquat", "nispero"],
        "he": ["שסק"]
      }
    },
    {
      "emoji": "🥭",
      "icon": "papaya",
      "words": {
        "en": ["papaya"],
        "he": ["פפאיה"]
      }
    },
    {
      "emoji": "🍐",
      "icon": "guava",
      "words": {
        "en": ["guava"],
        "he": ["גויאבה"]
      }
    },
    {
      "emoji": "🫐",
      "words": {
        "en": ["blackcurrant", "black currant", "redcurrant", "red currant"],
        "he": ["דומדמניות"]
      }
    },
    {
      "emoji": "🍇",
      "icon": "raisins",
      "words": {
        "en": ["raisin", "sultana", "currant", "dried fruit"],
        "he": ["צימוק", "פירות יבשים", "פירות מיובשים"]
      }
    },
    {
      "emoji": "🫐",
      "icon": "acai-bowl",
      "words": {
        "en": ["acai", "açaí", "açai"],
        "he": ["אסאי"]
      }
    },
    {
      "emoji": "🌴",
      "icon": "dates",
      "words": {
        "en": ["date", "medjool"],
        "he": ["תמר"]
      }
    },
    {
      "emoji": "🍇",
      "icon": "fig",
      "words": {
        "en": ["fig$", "figs$"],
        "he": ["תאנ"]
      }
    },
    {
      "emoji": "🍍",
      "words": {
        "en": ["pineapple"],
        "he": ["אננס"]
      }
    },
    {
      "emoji": "🍎",
      "words": {
        "en": ["apple"],
        "he": ["תפוח"]
      }
    },
    {
      "emoji": "🍌",
      "words": {
        "en": ["banana", "plantain"],
        "he": ["בננה"]
      }
    },
    {
      "emoji": "🍊",
      "words": {
        "en": ["orange", "clementine", "mandarin", "tangerine", "satsuma", "kumquat"],
        "he": ["תפוז", "קלמנטינ", "מנדרינ", "קומקוואט", "פומלית"]
      }
    },
    {
      "emoji": "🍋",
      "words": {
        "en": ["lemon", "lime"],
        "he": ["לימון", "ליים"]
      }
    },
    {
      "emoji": "🍇",
      "words": {
        "en": ["grape"],
        "he": ["ענב"]
      }
    },
    {
      "emoji": "🍓",
      "words": {
        "en": ["strawberr"],
        "he": ["תות"]
      }
    },
    {
      "emoji": "🫐",
      "words": {
        "en": ["blueberr"],
        "he": ["אוכמני"]
      }
    },
    {
      "emoji": "🥝",
      "words": {
        "en": ["kiwi"],
        "he": ["קיווי"]
      }
    },
    {
      "emoji": "🫐",
      "words": {
        "en": ["berr", "gooseberr", "elderberr", "goji", "boysenberr", "huckleberr"],
        "he": ["פירות יער"]
      }
    },
    {
      "emoji": "🍒",
      "words": {
        "en": ["cherry", "cherries"],
        "he": ["דובדבן"]
      }
    },
    {
      "emoji": "🍑",
      "words": {
        "en": ["peach", "nectarine"],
        "he": ["אפרסק", "נקטרינ"]
      }
    },
    {
      "emoji": "🍐",
      "words": {
        "en": ["pear$", "pears$"],
        "he": ["אגס"]
      }
    },
    {
      "emoji": "🥭",
      "words": {
        "en": ["mango"],
        "he": ["מנגו"]
      }
    },
    {
      "emoji": "🍉",
      "words": {
        "en": ["watermelon"],
        "he": ["אבטיח"]
      }
    },
    {
      "emoji": "🍈",
      "words": {
        "en": ["melon", "cantaloupe", "honeydew", "galia"],
        "he": ["מלון", "גליה"]
      }
    },
    {
      "emoji": "🥥",
      "words": {
        "en": ["coconut"],
        "he": ["קוקוס"]
      }
    },
    {
      "emoji": "🌰",
      "icon": "pecans",
      "words": {
        "en": ["pecan"],
        "he": ["פקאן", "פקן"]
      }
    },
    {
      "emoji": "🌰",
      "icon": "hazelnuts",
      "words": {
        "en": ["hazelnut", "filbert"],
        "he": ["אגוזי לוז", "לוז"]
      }
    },
    {
      "emoji": "🌰",
      "icon": "walnuts",
      "words": {
        "en": ["walnut"],
        "he": ["אגוזי מלך", "אגוז מלך"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "cashews",
      "words": {
        "en": ["cashew"],
        "he": ["קשיו"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "pistachios",
      "words": {
        "en": ["pistachio"],
        "he": ["פיסטוק"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "almonds",
      "words": {
        "en": ["almond"],
        "he": ["שקד"]
      }
    },
    {
      "emoji": "🥜",
      "icon": "trail-mix",
      "words": {
        "en": ["trail mix", "nut mix", "mixed nuts", "student mix"],
        "he": ["מיקס אגוזים", "תערובת אגוזים", "פיצוחים"]
      }
    },
    {
      "emoji": "🥜",
      "words": {
        "en": ["peanut", "nut$", "nuts$"],
        "he": ["בוטן", "אגוז"]
      }
    },
    {
      "emoji": "🍫",
      "words": {
        "en": ["chocolat", "snickers", "twix", "kitkat", "kit kat", "bounty"],
        "he": ["שוקולד"]
      }
    },
    {
      "emoji": "🍯",
      "words": {
        "en": ["honey"],
        "he": ["דבש"],
        "fr": ["miel"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "caramel",
      "words": {
        "en": ["caramel", "toffee", "fudge", "dulce de leche"],
        "he": ["קרמל", "טופי", "פאדג'"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "marshmallows",
      "words": {
        "en": ["marshmallow"],
        "he": ["מרשמלו"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "chewing-gum",
      "words": {
        "en": ["chewing gum", "bubble gum", "gum$"],
        "he": ["מסטיק"]
      }
    },
    {
      "emoji": "🍬",
      "words": {
        "en": [
          "candy",
          "nougat",
          "marzipan",
          "liquorice",
          "licorice",
          "sprinkles",
          "mints$",
          "mentos",
          "candies"
        ],
        "he": ["סוכרי", "ממתק", "מרציפן", "ליקריץ", "סוכריות"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "protein-shake",
      "words": {
        "en": ["protein"]
      }
    },
    {
      "emoji": "💧",
      "icon": "water-bottle",
      "words": {
        "en": ["soda water", "club soda", "sparkling water", "seltzer", "mineral water"],
        "he": ["סודה", "מים מוגזים", "נביעות"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "energy-gel",
      "words": {
        "en": ["energy gel", "sports gel", "gel$", "gels$"],
        "he": ["ג'ל אנרגיה"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "sports-drink",
      "words": {
        "en": ["sports drink", "gatorade", "powerade", "isotonic", "electrolyte", "lucozade"],
        "he": ["משקה ספורט", "איזוטוני", "אלקטרוליט", "פאוורייד"]
      }
    },
    {
      "emoji": "🥤",
      "icon": "soda-can",
      "words": {
        "en": [
          "cola",
          "coke",
          "soda",
          "pepsi",
          "sprite",
          "fanta",
          "7up",
          "seven up",
          "ginger ale",
          "tonic",
          "soft drink",
          "ginger beer",
          "root beer"
        ],
        "he": ["קולה", "ספרייט", "פנטה", "פפסי", "משקה מוגז", "טוניק", "ג'ינג'ר אייל"]
      }
    },
    {
      "emoji": "🫚",
      "words": {
        "en": ["ginger$", "ginger root", "galangal"],
        "he": ["ג'ינג'ר", "זנגביל"]
      }
    },
    {
      "emoji": "⚡",
      "icon": "energy-drink",
      "words": {
        "en": ["energy drink", "red bull", "redbull", "monster energy", "xl energy"],
        "he": ["משקה אנרגיה", "רד בול", "אקס אל"]
      }
    },
    {
      "emoji": "🍵",
      "icon": "kombucha",
      "words": {
        "en": ["kombucha"],
        "he": ["קומבוצ'ה", "קומבוצה"]
      }
    },
    {
      "emoji": "💧",
      "icon": "water-bottle",
      "words": {
        "en": ["water"],
        "he": ["מים"]
      }
    },
    {
      "emoji": "🍺",
      "words": {
        "en": ["beer"],
        "he": ["בירה"]
      }
    },
    {
      "emoji": "🍷",
      "words": {
        "en": ["wine"],
        "he": ["יין"]
      }
    },
    {
      "emoji": "🍸",
      "words": {
        "en": ["cocktail", "margarita", "mojito", "spritz", "martini", "sangria"],
        "he": ["קוקטייל", "מוחיטו", "מרגריטה"]
      }
    },
    {
      "emoji": "🥃",
      "words": {
        "en": ["whisky", "whiskey", "vodka", "tequila", "arak"],
        "he": ["ויסקי", "וודקה", "ערק", "ג'ין"]
      }
    },
    {
      "emoji": "🫗",
      "words": {
        "en": ["oil"],
        "he": ["שמן"]
      }
    },
    {
      "emoji": "🧂",
      "words": {
        "en": ["salt"],
        "he": ["מלח"]
      }
    },
    {
      "emoji": "🥨",
      "words": {
        "en": ["pretzel"]
      }
    },
    {
      "emoji": "🫒",
      "words": {
        "en": ["olive", "caper"],
        "he": ["זית", "צלפ"]
      }
    },
    {
      "emoji": "🍫",
      "words": {
        "en": ["bar$", "bars$"],
        "he": ["חטיף"]
      }
    },
    {
      "emoji": "🌿",
      "icon": "herbs",
      "words": {
        "en": [
          "herb",
          "mint",
          "basil",
          "coriander",
          "cilantro",
          "parsley",
          "dill",
          "rosemary",
          "thyme"
        ],
        "he": [
          "עשבי תיבול",
          "נענע",
          "בזיליקום",
          "כוסברה",
          "פטרוזיליה",
          "שמיר",
          "רוזמרין",
          "טימין",
          "מרווה"
        ],
        "it": ["basilico"],
        "de": ["kräuter"]
      }
    },
    {
      "emoji": "🌻",
      "icon": "sunflower-seeds",
      "words": {
        "en": ["seed", "hemp"]
      }
    },
    {
      "emoji": "🧈",
      "icon": "cream-cheese",
      "words": {
        "en": ["spread", "margarine"],
        "he": ["ממרח", "מרגרינה"]
      }
    },
    {
      "emoji": "🥛",
      "icon": "chocolate-milk",
      "words": {
        "he": ["שוקו"]
      }
    },
    {
      "emoji": "🍬",
      "icon": "sugar",
      "words": {
        "en": ["sugar"],
        "he": ["סוכר"]
      }
    },
    {
      "emoji": "🍬",
      "words": {
        "en": ["sweet"],
        "he": ["מתוק"]
      }
    },
    {
      "emoji": "🧀",
      "icon": "labneh",
      "words": {
        "he": ["לבנה"]
      }
    },
    {
      "emoji": "🥣",
      "icon": "yogurt-cup",
      "words": {
        "he": ["לבן", "גיל"]
      }
    },
    {
      "emoji": "🍶",
      "icon": "soy-sauce",
      "words": {
        "en": ["sauce", "dip$", "dips$", "gravy", "marinade"],
        "he": ["רוטב", "מטבל"]
      }
    }
  ]
}
